<template>
    <div>
        <b-list-group class="list">
            <b-list-group-item button class="list-item" v-for="bolla in bolleList" :key="bolla.uid">
                <b-row >
                    <b-col class="list-item-left"><span> {{bolla.nome}}</span></b-col>
                    <b-col class="list-item-center"><span> {{format_date(bolla.data_bolla)}}</span></b-col>
                    <b-col class="list-item-right">
                        <img v-if="bolla.verificata" src="@/assets/verified-primary.svg" class="verified-img" />
                        <img v-if="!bolla.verificata" src="@/assets/verified-secondary.svg" class="verified-img" @click="openVerifyModal(bolla)"/>
                        <img src="@/assets/document.svg" class="doc-img" @click="openBollaModal(bolla)" />
                    </b-col>
                </b-row>
            </b-list-group-item>
        </b-list-group>

        <!-- Bolle Modal -->
        <b-modal id="bollaDetailModal" size="xl" :hide-header="true" :hide-footer="true">
            <BollaDetails :bolla="bolla" @closeModal="$bvModal.hide('bollaDetailModal');" />
        </b-modal>
        <!-- Confirm modal -->
        <b-modal id="bollaVerifyModal" class="verify-modal-body"  title="Conferma verifica bolla" ok-variant="success" cancel-title="Annulla" button-size="sm" @ok="verifyBolla(bolla)">
            <span>Sei sicuro/a di voler verificare questa bolla?</span>
        </b-modal>
    </div>
</template>

<script>
import {mixins} from '@/mixins';
import BollaDetails from '@/components/Bolla-Details.vue';

export default {
    name: "ListaBolle",
    data(){
        return {
            bolleList: Array,
            bolla: Object
        }
    },
    props:{
        id_pratica: String,
    },
    components: {
        BollaDetails
    },
    mixins: [mixins],
    created(){
        this.$axios
        .get(this.$apibase + '/api/bolle/get_bolle_by_pratica/' ,
            {
                headers:{
                    Authorization:"JWT " + localStorage.getItem('access_token')
                },
                params: {
                    pratica: this.id_pratica
                }
            }
        )
        .then(response => {
            this.bolleList = response.data.sort((a, b) => (Date.parse(b.data_bolla) - Date.parse(a.data_bolla)));
        })
        .catch(e => {
            if (e.response.status == 403)
                this.logout();
            else
                alert(e);
        })
    },
     methods: {
        openBollaModal: function(bolla){
            this.bolla = bolla;
            this.$bvModal.show('bollaDetailModal');
        },
        openVerifyModal: function(bolla){
            this.bolla = bolla;
            this.$bvModal.show('bollaVerifyModal');
        },
        verifyBolla: function(bolla){
            this.$axios
            .post(this.$apibase + '/api/bolle/verify_bolla/',
                {
                    bolla: bolla.uid
                },
                {
                    headers: {
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    }
                }
            )
            .then(() => {
                bolla.verificata = true
            })
            .catch((e) => {
                if (e.response.status == 403)
                    this.logout();
                else {
                    alert(e);
                    console.log(e)
                }
            })
        }
    }
}
</script>

<style scoped>
    .list-item{
        padding-left: 40px;
        padding-right: 40px;
        color: #707070;
    }
    .verified-img{
        width: 20px;
    }
    .list-item-right{
        text-align: right;
    }
    .list-item-center{
        text-align: center;
    }
    .list-item-left{
        text-align: left;
    }
    .doc-img{
        width: 20px;
        margin-left: 20px;
    }
    .verify-modal-body{
        padding:30px 0;
    }
</style>